export default {
  tag: "Approved Partners",
  title1: "Commissary",
  title2: "Kitchens",
  subtitle:
    "Reliable commissary partners across Orange County for catering trucks and prepackaged food operations.",
  cateringTrucks: "Catering Trucks",
  prepackagedTrucks: "Prepackaged Trucks",
  needHelp: "Need Help Choosing?",
  needHelpText:
    "Not sure which commissary is right for your operation? We can help match you with the best fit based on your location and truck type.",
  bookSession: "Book a Session",
};